import theme from 'theme'

/* Components */
import WaveSkeleton from './WaveSkeleton'

const StubBenchmarkCard = () => (
  <WaveSkeleton height={36} sx={{ borderRadius: theme.attributes.borderRadius.secondary }} />
)

export default StubBenchmarkCard
